import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AddDuplicateHelpdesk from './addDuplicateHelpdesk';
import {
    createDuplicateHelpdesk,
    getHelpdeskDataForUpdation,
    // getLeadInfraId
} from 'services/redux/brandActivtion/conductCamp/action';
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    carnivalData: state.ConductCampReducer.helpdeskData,
    leadInfraId: state.ConductCampReducer.leadInfraId,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        documentUploadUrlPublic,
      getHelpdeskDataForUpdation,
      createDuplicateHelpdesk,
        // getLeadInfraId
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AddDuplicateHelpdesk);
